<script setup lang="ts">
import { map } from "lodash-es";

const platforms = map(
  import.meta.glob("@/assets/images/marketing/platforms/*.png", {
    eager: true,
  }),
  "default",
);

const devices = [
  {
    icon: "/images/marketing/devices/phone.png",
    label: "Phone",
  },
  {
    icon: "/images/marketing/devices/tablet.png",
    label: "Tablet",
  },
  {
    icon: "/images/marketing/devices/laptop.png",
    label: "Laptop",
  },
  {
    icon: "/images/marketing/devices/smart_tv.png",
    label: "Smart TV",
  },
];
</script>

<template>
  <div class="my-10">
    <div class="mb-5 text-center text-3xl font-bold">
      Stream PokerGO on your favorite platform
    </div>

    <div
      class="grid grid-cols-2 gap-4 text-center text-2xl md:grid-cols-4 md:gap-5"
    >
      <div
        v-for="(device, i) in devices"
        :key="`device_${i}`"
        class="flex items-center gap-3 rounded-xl border border-surface-border bg-surface-bg p-5 md:gap-5"
      >
        <div
          class="flex h-16 w-16 items-center justify-center rounded-xl bg-black"
        >
          <img :src="device.icon" :alt="device.label" />
        </div>
        <div class="text-base md:text-lg">{{ device.label }}</div>
      </div>
    </div>

    <div
      class="mt-6 grid grid-cols-2 gap-4 text-center text-2xl md:grid-cols-6 md:gap-5"
    >
      <div
        v-for="(device, i) in platforms"
        :key="`device_${i}`"
        class="flex h-20 items-center justify-center rounded-xl border border-surface-border bg-surface-bg p-4"
      >
        <img :src="device" alt="on-demand-img" />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
